import api from '@/api';
import axios from 'axios';

/**
 * 腾讯云上传文件
 * @param {*} fileName 文件名
 * @param {*} file 文件对象
 * @param {*} type 文件类型，接口定义
 * @param {*} onProgress 上传进度回调方法
 */
export function cloudUpload({ fileName = '', file, type, onProgress }) {
  return new Promise((resolve, reject) => {
    api
      .get_upload_sign({
        fileName,
        type: type || '3'
      })
      .then(res => {
        if (res._ret !== '0') {
          reject(res);
          return false;
        }
        upload({
          url: res.data.url,
          authorization: res.data.signature,
          file,
          callback: onProgress
        })
          .then(function(res) {
            resolve(res);
          })
          .catch(function(err) {
            reject(err);
          });
      });
  });
}

export function upload({ url, authorization, file, callback }) {
  return new Promise((resolve, reject) => {
    let uploadData = new FormData();
    uploadData.append('filecontent', file);
    uploadData.append('op', 'upload');
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        authorization: authorization
      },
      onUploadProgress: function(progressEvent) {
        // 上传进度
        if (progressEvent.lengthComputable) {
          callback && callback(progressEvent);
        }
      }
    };
    axios
      .post(url, uploadData, config)
      .then(res => {
        if (res.data.code === 0) {
          resolve(res.data);
        } else {
          reject(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}
